/**
 * @generated SignedSource<<edbd15b46d5e0a618bf62d3c05a40adc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClassAccessControl = "FLEXIBLE" | "PROGRESSIVE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type cursos_lesson$data = {
  readonly __typename: string;
  readonly canAccess: boolean;
  readonly course: {
    readonly classAccessControl: ClassAccessControl;
    readonly member: {
      readonly enrolledAt: any;
      readonly id: string;
      readonly memberGroup: {
        readonly group: {
          readonly releaseTimeline: ReadonlyArray<{
            readonly daysToRelease: number | null | undefined;
            readonly notAvailableBefore: any | null | undefined;
            readonly section: {
              readonly id: string;
            };
          }> | null | undefined;
        };
      };
    } | null | undefined;
    readonly name: string;
    readonly progress: number;
    readonly slug: string;
    readonly " $fragmentSpreads": FragmentRefs<"courseSectionsPreview">;
  };
  readonly id: string;
  readonly name: string;
  readonly previousClass: {
    readonly completed: boolean;
  } | null | undefined;
  readonly section: {
    readonly id: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"courseLesson_lesson" | "courseQuiz_quiz" | "lessonBlocked_lesson">;
  readonly " $fragmentType": "cursos_lesson";
};
export type cursos_lesson$key = {
  readonly " $data"?: cursos_lesson$data;
  readonly " $fragmentSpreads": FragmentRefs<"cursos_lesson">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseSection",
  "kind": "LinkedField",
  "name": "section",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "username"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "cursos_lesson",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canAccess",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "previousClass",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completed",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Course",
      "kind": "LinkedField",
      "name": "course",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "progress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "classAccessControl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "user",
              "variableName": "username"
            }
          ],
          "concreteType": "CourseMember",
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "enrolledAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CourseMemberGroupMember",
              "kind": "LinkedField",
              "name": "memberGroup",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseMemberGroup",
                  "kind": "LinkedField",
                  "name": "group",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SectionReleaseTimeline",
                      "kind": "LinkedField",
                      "name": "releaseTimeline",
                      "plural": true,
                      "selections": [
                        (v2/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "daysToRelease",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "notAvailableBefore",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "courseSectionsPreview"
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "courseLesson_lesson"
        }
      ],
      "type": "CourseContent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "courseQuiz_quiz"
        }
      ],
      "type": "CourseQuiz",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "lessonBlocked_lesson"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "CourseClass",
  "abstractKey": "__isCourseClass"
};
})();

(node as any).hash = "e7a691eb27e74aabc59de12e16a2556f";

export default node;
